// Vuex authServicesPoints module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  tokenIsValid: false,
  isWaitingForAuthServicePointData: true,
  initialParams: [],
  params: [],
  type: null,
  platform_url: null,
  gateway: null,
  afterAuthorizationUrl: null,
  // string data for qr generator
  qrCode: '',
  // token for access and setup
  loginToken: '',
  // informs the user how much time they have to enter otp code
  otpStamp: null,
  // if user gets blocked this stores the unlock stamp
  unlockStamp: null,
};

const getters = {
  tokenIsValid: state => state.tokenIsValid,
  isWaitingForAuthServicePointData: state => state.isWaitingForAuthServicePointData,
  form: state => ({
    params: state.params,
    type: state.type,
  }),
  gateway: state => state.gateway,
  platformUrl: state => state.platform_url,
  afterAuthorizationUrl: state => state.afterAuthorizationUrl,
  qrCode: state => state.qrCode,
  loginToken: state => state.loginToken,
  otpStamp: state => state.otpStamp,
  unlockStamp: state => state.unlockStamp
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/authServicesPoints/index.js